import {API_ACTION, API_GENERIC_REVIEW_QUESTION, API_GENERIC_REVIEW_QUESTION_QUESTION} from '../../const/Api';
import {RestApiMethod} from '../../const/dataEnum';
import {callAPI} from './callApi';

const update = async (questions) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.POST,
      url: API_GENERIC_REVIEW_QUESTION + API_ACTION.UPDATE,
      data: questions,
    });
    return res.data;
  } catch (error) {
    console.error('update Error:', error.message);
    return null;
  }
};

const updateBatch = async (questions) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.POST,
      url: API_GENERIC_REVIEW_QUESTION + API_ACTION.UPDATE + API_ACTION.BATCH,
      data: questions,
    });
    return res.data;
  } catch (error) {
    console.error('updateBatch Error:', error.message);
    return null;
  }
};

const getAllQuestionByDepartmentId = async (departmentId) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: `${API_GENERIC_REVIEW_QUESTION_QUESTION}${departmentId}`,
    });
    return res.data.data;
  } catch (error) {
    console.error('getAllQuestion By Department ID Error:', error.message);
    return null;
  }
};

const getAllQuestionByPeriodAndDepartement = async (departmentId, periodId) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: `${API_GENERIC_REVIEW_QUESTION}/questions?departmentId=${departmentId}&periodId=${periodId}`,
    });
    return res.data.data;
  } catch (error) {
    console.error('getAllQuestion By Period and Department Error:', error.message);
    return null;
  }
};

const deleteGenericQuestion = async (id) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.POST,
      url: API_GENERIC_REVIEW_QUESTION + API_ACTION.DELETE,
      data: id,
    });
    return res.data;
  } catch (error) {
    console.error('Delete Generic Review Question Error:', error.message);
  }
};

const genericReviewQuestionApi = {
  update,
  updateBatch,
  getAllQuestionByDepartmentId,
  getAllQuestionByPeriodAndDepartement,
  deleteGenericQuestion,
};

export default genericReviewQuestionApi;
